import { keyframes } from '@emotion/react';
import { Box } from '@mui/material';

export const LIVE_DOT_SIZE = 8;

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const LiveDot = () => (
  <Box
    sx={(theme) => ({
      width: LIVE_DOT_SIZE,
      height: LIVE_DOT_SIZE,
      borderRadius: '50%',
      backgroundColor: theme.palette.error.main,
      animation: `${pulse} 1.4s ease-in-out infinite`,
      '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
    })}
  />
);

export default LiveDot;
